import * as React from "react";

import { IAuthClient, AuthContextProps, IAuthContext } from "../types";

const AuthContext = React.createContext<AuthContextProps>(null);
const { Provider, Consumer } = AuthContext;

interface IProps {
  children: React.ReactNode;
  client: IAuthClient;
}

class StatefulProvider extends React.Component<IProps, IAuthContext> {
  methods = this.prepareMethods();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isInitialized: false,
      isAuthenticated: false,
      token: "",
      user: null,
      updateUser: () => {},
      ...this.methods
    };
  }

  syncState = () => {
    const { client } = this.props;

    this.setState({
      isInitialized: client.getIsInitialized(),
      isAuthenticated: client.getIsAuthenticated(),
      token: client.getToken(),
      user: client.getUser(),
      ...this.methods
    });
  };

  prepareMethods() {
    const { client } = this.props;

    return {
      loginWithUserAndPassword: client.loginWithUserAndPassword.bind(client),
      logout: client.logout.bind(client),
      init: client.init.bind(client),
      getToken: client.getToken.bind(client),
      updateUser: client.updateUser.bind(client),
      getFreshToken: client.getFreshToken.bind(client),
      checkAccess: client.checkAccess.bind(client)
    };
  }

  componentDidMount() {
    this.props.client.registerOnUpdateHandler(this.syncState);
  }

  render() {
    const { children } = this.props;

    return <Provider value={this.state}>{children}</Provider>;
  }
}

export { Consumer as AuthConsumer, StatefulProvider as AuthProvider };

const useAuth = () => React.useContext(AuthContext)!;

export default useAuth;
